import { formatMoney, projectCurrency, resolveHourlyRate, type Dataset, type Project } from "@otrack/domain";

/** "$28/h", "Fixed, CLP 3,200,000", "Non-billable". */
export function billingSummary(dataset: Dataset, project: Project): string {
  const currency = projectCurrency(dataset, project);
  if (project.billingMode === "non-billable") return "Non-billable";
  if (project.billingMode === "fixed") return project.fixedPrice === null ? `Fixed price per task, ${currency}` : `Fixed, ${formatMoney({ amount: project.fixedPrice, currency })}`;
  const client = project.clientId ? dataset.clients[project.clientId] : undefined;
  const rate = resolveHourlyRate(project, client, dataset.settings);
  return rate ? `${formatMoney(rate)}/h` : `Hourly, no rate set (${currency})`;
}
